Ext.define('SA.view.TableBorderSizes', {
    constructor({width, height}) {
        this.width = width;
        this.height = height;
    },

    getHeight() {
        return this.height;
    },

    getWidth() {
        return this.width;
    }
});